import { Axial } from '../game/map/HexCoordinates';

/**
 * Odpoczynek po drucie.
 *
 * Dwie trasy HTTP, jak każda inna akcja na budynku — a **zdejmowanie z mapy
 * i wracanie na nią jedzie socketem**, i to nie są dwie wiadomości do
 * dopisania: dla stojących obok położenie się jest `playerLeft`, a wstanie
 * `playerJoined`. Z zewnątrz to jest dokładnie to samo, co wyjście z zasięgu
 * i wejście w niego, więc klient nie musi rozróżniać niczego nowego.
 *
 * O **swoim** stanie klient dowiaduje się z wiadomości `rest`, nie z odpowiedzi
 * na te wywołania: budzi też serwer, sam z siebie, przy pierwszej rzeczy
 * wymagającej ciała na mapie. Odpowiedź mówi więc, co się udało, a stanem
 * rządzi to, co przyszło socketem.
 */

const API = import.meta.env.VITE_API_URL ?? '';

export interface Resting {
  building: string;
  /** Pole osady — kładąc się, gracz przechodzi na nie. */
  position: Axial;
}

export interface Refused {
  code: string;
  message: string;
}

/** Połóż się w swojej osadzie. */
export async function rest(token: string, building: string): Promise<Resting | Refused> {
  const response = await fetch(`${API}/api/world/rest`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ building }),
  });

  const body = await response.json().catch(() => ({ code: 'broken', message: 'brak odpowiedzi' }));
  return response.ok ? (body as Resting) : (body as Refused);
}

/** Wstań. Odpowiada odmową, gdy nie było skąd. */
export async function wake(token: string): Promise<Refused | null> {
  const response = await fetch(`${API}/api/world/wake`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (response.ok) return null;
  return (await response
    .json()
    .catch(() => ({ code: 'broken', message: 'brak odpowiedzi' }))) as Refused;
}
